import React from 'react';
import Empty from '../../assets/empty.svg';

interface Props {
    text: string
}

export default function EmptyPlaceholder({text}: Props) {
    return (
            <div className='h-full flex flex-col place-content-center text-center mx-auto'>
                <div className='flex flex-col justify-center items-center'>
                    <img
                        src={Empty}
                        width={220}
                        height={138}
                        alt="Empty placeholder"
                    />
                    <span className='text-melon-grey-dark'>{text}</span>
                </div>
            </div>
    );
}